import { format } from 'date-fns'
import { useMutation } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { parseStatementPeriod } from '@webapp/platform/banking/utils/parseStatementPeriod'
import { downloadBlob } from '@webapp/utils/downloadBlob'

/**
 * Deliberately formatted with date-fns rather than `intl` — a filename should
 * not change with the viewer's locale.
 */
const buildFileName = (datePeriod: string) =>
  `Procurify_MonthlyStatement_${format(
    parseStatementPeriod(datePeriod),
    'MMMMyyyy'
  )}.pdf`

export const useMutateDownloadFinancialAccountStatement = () => {
  const mutation = useMutation<
    void,
    RepoError,
    { financialAccountId: number; datePeriod: string }
  >({
    mutationFn: async ({ financialAccountId, datePeriod }) => {
      const data = await financialAccountRepository.getStatement(
        financialAccountId,
        datePeriod
      )

      downloadBlob(
        new Blob([data], { type: 'application/pdf' }),
        buildFileName(datePeriod)
      )
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
